import { PFPT_EXPERIMENTAL } from '../common/constants/definitions';

export const isExperimentalMode = () => Boolean( sessionStorage.getItem( PFPT_EXPERIMENTAL ) );

export const shouldOverrideNavBarColor = ( isExperimental, environment ) => {
    return isExperimental && ( environment === 'local' || environment === 'dev' );
};

